var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-alert",
        { staticClass: "mb-2", attrs: { variant: "info", show: "" } },
        [
          _c("div", { staticClass: "alert-body" }, [
            _vm._v(
              " A região de atuação é o que coloca na busca quem não tem endereço comercial. Guarde bairro e cidade — "
            ),
            _c("strong", [
              _vm._v("nunca o endereço residencial do profissional"),
            ]),
            _vm._v(", que não é publicado. "),
          ]),
        ]
      ),
      _c("div", { staticClass: "vx-row mb-4" }, [
        _c(
          "div",
          { staticClass: "vx-col sm:w-1/4 w-full" },
          [
            _c(
              "b-form-group",
              {
                attrs: {
                  label: "Raio de atendimento (km)",
                  "label-for": "service_radius_km",
                },
              },
              [
                _c("b-form-input", {
                  attrs: {
                    id: "service_radius_km",
                    type: "number",
                    min: "0",
                    name: "service_radius_km",
                  },
                  model: {
                    value: _vm.professional.service_radius_km,
                    callback: function ($$v) {
                      _vm.$set(_vm.professional, "service_radius_km", $$v)
                    },
                    expression: "professional.service_radius_km",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "vx-col sm:w-3/4 w-full flex items-end" },
          [
            _c(
              "b-button",
              {
                staticClass: "mb-1",
                attrs: { variant: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("save-radius")
                  },
                },
              },
              [_vm._v(" Salvar raio de atendimento ")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "validation-observer",
        { ref: "serviceAreaForm" },
        [
          _c(
            "b-form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "vx-row" }, [
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/4 w-full" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: "Estado",
                          "label-for": "federation_unit",
                        },
                      },
                      [
                        _c(
                          "v-select",
                          {
                            attrs: {
                              id: "federation_unit",
                              options: _vm.federationUnitList,
                              label: "name",
                            },
                            on: { input: _vm.loadCities },
                            model: {
                              value: _vm.federationUnit,
                              callback: function ($$v) {
                                _vm.federationUnit = $$v
                              },
                              expression: "federationUnit",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                attrs: { slot: "no-options" },
                                slot: "no-options",
                              },
                              [_vm._v("Nenhum registro encontrado!")]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/4 w-full" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Cidade", "label-for": "city" } },
                      [
                        _c("validation-provider", {
                          attrs: { name: "Cidade", rules: "required" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c(
                                    "v-select",
                                    {
                                      attrs: {
                                        id: "city",
                                        options: _vm.cityList,
                                        label: "name",
                                        disabled: !_vm.federationUnit,
                                      },
                                      model: {
                                        value: _vm.area.city,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.area, "city", $$v)
                                        },
                                        expression: "area.city",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "no-options" },
                                          slot: "no-options",
                                        },
                                        [_vm._v("Nenhum registro encontrado!")]
                                      ),
                                    ]
                                  ),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0])),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/4 w-full" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: "Bairro",
                          "label-for": "district_name",
                        },
                      },
                      [
                        _c("b-form-input", {
                          attrs: { id: "district_name", name: "district_name" },
                          model: {
                            value: _vm.area.district_name,
                            callback: function ($$v) {
                              _vm.$set(_vm.area, "district_name", $$v)
                            },
                            expression: "area.district_name",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/4 w-full" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Região principal" } },
                      [
                        _c(
                          "b-form-checkbox",
                          {
                            staticClass: "mt-1",
                            model: {
                              value: _vm.area.head,
                              callback: function ($$v) {
                                _vm.$set(_vm.area, "head", $$v)
                              },
                              expression: "area.head",
                            },
                          },
                          [_vm._v(" Usar como referência na busca ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "vx-row" }, [
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/4 w-full" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Latitude", "label-for": "latitude" } },
                      [
                        _c("b-form-input", {
                          attrs: { id: "latitude", name: "latitude" },
                          model: {
                            value: _vm.area.latitude,
                            callback: function ($$v) {
                              _vm.$set(_vm.area, "latitude", $$v)
                            },
                            expression: "area.latitude",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/4 w-full" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: { label: "Longitude", "label-for": "longitude" },
                      },
                      [
                        _c("b-form-input", {
                          attrs: { id: "longitude", name: "longitude" },
                          model: {
                            value: _vm.area.longitude,
                            callback: function ($$v) {
                              _vm.$set(_vm.area, "longitude", $$v)
                            },
                            expression: "area.longitude",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/2 w-full flex items-end" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "mb-1",
                        attrs: {
                          variant: "primary",
                          type: "submit",
                          disabled: !_vm.area.city,
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.area.id ? "Alterar" : "Adicionar") +
                            " "
                        ),
                      ]
                    ),
                    _vm.area.id
                      ? _c(
                          "b-button",
                          {
                            staticClass: "mb-1 ml-2",
                            attrs: { variant: "outline-secondary" },
                            on: { click: _vm.resetForm },
                          },
                          [_vm._v(" Cancelar ")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _c("small", { staticClass: "text-muted d-block mb-2" }, [
                _vm._v(
                  " Deixe as coordenadas em branco para herdar as da cidade quando forem confiáveis. "
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _c("div", { staticClass: "vx-row mt-4 mb-10" }, [
        _c(
          "div",
          { staticClass: "vx-col w-full" },
          [
            _c(
              "vs-table",
              {
                attrs: {
                  data: _vm.areaList,
                  "no-data-text": "Nenhuma região cadastrada",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var data = ref.data
                      return _vm._l(data, function (tr, indextr) {
                        return _c(
                          "vs-tr",
                          { key: indextr },
                          [
                            _c("vs-td", [
                              _vm._v(_vm._s(_vm.cityNameOf(data[indextr]))),
                            ]),
                            _c("vs-td", [
                              _vm._v(_vm._s(data[indextr].district_name)),
                            ]),
                            _c(
                              "vs-td",
                              [
                                data[indextr].head
                                  ? _c("feather-icon", {
                                      staticClass:
                                        "h-5 w-5 stroke-current text-success",
                                      attrs: { icon: "CheckIcon" },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c("vs-td", [
                              _c(
                                "div",
                                { staticClass: "flex flex-row gap-2" },
                                [
                                  _c("feather-icon", {
                                    staticClass: "h-5 w-5 mr-1 stroke-current",
                                    staticStyle: { cursor: "pointer" },
                                    attrs: { icon: "EditIcon" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.edit(data[indextr])
                                      },
                                    },
                                  }),
                                  _c("feather-icon", {
                                    staticClass:
                                      "h-5 w-5 mr-1 stroke-current text-danger",
                                    staticStyle: { cursor: "pointer" },
                                    attrs: { icon: "Trash2Icon" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.destroy(data[indextr])
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        )
                      })
                    },
                  },
                ]),
              },
              [
                _c(
                  "template",
                  { slot: "thead" },
                  [
                    _c("vs-th", [_vm._v("Cidade")]),
                    _c("vs-th", [_vm._v("Bairro")]),
                    _c("vs-th", [_vm._v("Principal")]),
                    _c("vs-th", [_vm._v("Ação")]),
                  ],
                  1
                ),
              ],
              2
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }